<template>
  <div class="tw-min-h-[calc(100vh-146px)] tw-bg-bgPage">
    <BaseTopLine> </BaseTopLine>

    <VueTabs
      v-model="currentCountry"
      @tab-change="handleTabChange"
      class="vue-tabs-type-1"
    >
      <VTab
        v-for="country of countriesList"
        :title="country.countries__name"
        :key="country.countries__id"
        :data="country"
      >
      </VTab>
    </VueTabs>

    <div class="tw-px-[26px] tw-mt-[15px]">
      <div class="tw-mb-[15px] tw-flex tw-items-center tw-gap-[10px]">
        <button
          class="tw-app-btn-primary"
          @click="
            () => {
              isTypeCreateModal = true;
              dataForModal.academy__video_link = 'https://';
              $modal.show('addNote');
              isOpenModal = true;
            }
          "
        >
          <img
            :src="require(`@/assets/icons/addwhite.svg`)"
            width="13.5"
            height="13.5"
            class="tw-my-[-5px]"
          />
          {{ dataLang["register_academy_text_1"] }}
        </button>
        <button class="tw-app-btn-primary-outline" @click="deleteRow">
          <img
            :src="require(`@/assets/icons/minus-dark.svg`)"
            width="13.5"
            height="13.5"
            class="tw-my-[-5px]"
          />
          {{ dataLang["register_academy_text_2"] }}
        </button>
      </div>
      <div class="tw-flex tw-justify-between">
        <div class="tw-flex">
          <button @click="loadData()" class="tw-app-btn-primary-outline">
            {{ dataLang["register_btn_filter_on"] }}
          </button>
          <button
            @click="resetFilter"
            class="tw-app-btn-light !tw-text-[#0056AF]"
          >
            {{ dataLang["register_btn_filter_off"] }}
          </button>
        </div>
        <TwBasePagination
          :page-count="numPages"
          :pagination-params="{
            ...paginationFinesStateParams,
            limit: limitPaginationValue,
          }"
          :showLimitInput="true"
          @updateLimitValue="updateLimitValue"
          :page-range="10"
          :margin-pages="0"
          :click-handler="loadData"
        >
        </TwBasePagination>
      </div>

      <div class="tw-relative tw-mt-[15px]" style="min-height: 400px">
        <BaseLoader v-if="localLoading" style="z-index: 50"></BaseLoader>
        <ve-table
          class="rest-style-table fixed-header"
          style="width: 100%; z-index: 1"
          :columns="columns"
          :table-data="dataTable"
          :border-x="true"
          :border-y="true"
          row-key-field-name="academy__id"
          ref="mainTable"
          :eventCustomOption="eventCustomOption"
          :cell-style-option="cellStyleOption"
          :checkbox-option="{
            selectedRowChange: selectedRowChange,
            selectedAllChange: selectedAllChange,
            hideSelectAll: false,
          }"
          :clickHighlight="false"
          :rowStyleOption="{
            hoverHighlight: true,
          }"
          :cellSelectionOption="{ enable: false }"
          :sort-option="sortOption"
        >
        </ve-table>
      </div>
    </div>

    <BaseModal
      name="addNote"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      @beforeOpen="onOpenMainModal"
      @beforeClose=""
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container" v-if="isOpenModal">
        <BaseLoader v-if="localLoading" style="z-index: 100"></BaseLoader>
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="
            () => {
              $modal.hide('addNote');
              updatedValues = {};
              dataForModal = {
                academy__video_link: 'https://',
                academy__subject: '',
                academy__country_id: null,
                academy__is_welcome: false,
                academy__tags: '',
                academy__welcome_description: '',
                academy__welcome_position: 0,
                academy__welcome_title: '',
              };
              fileId = '';
              fileUrl = '';
            }
          "
        ></button>
        <div>
          <div class="tw-app-modal__title">
            {{ dataLang["register_academy_text_4"] }}
          </div>

          <div class="tw-mb-[15px]" ref="academy__subject">
            <!-- <div class="tw-app-input-type-3-label">Город</div> -->
            <BaseTextarea
              inputClass="tw-app-input-type-3"
              input-name="academy__subject"
              @onInput="updateValue"
              name-sign=""
              :minHeight="'82'"
              :value="dataForModal?.academy__subject"
            >
            </BaseTextarea>
          </div>

          <div class="tw-mb-[15px]" ref="academy__video_link">
            <div class="tw-app-input-type-3-label">
              {{ dataLang["register_academy_text_8"] }}
            </div>
            <BaseInputNew
              inputClass="tw-app-input-type-3"
              input-name="academy__video_link"
              @input="updateValue"
              :value="dataForModal.academy__video_link"
              :horizontalTitle="false"
            >
            </BaseInputNew>
          </div>

          <div class="tw-mb-[15px]" ref="academy__welcome_title">
            <BaseCheckboxV2
              input-name="academy__is_welcome"
              v-model="dataForModal.academy__is_welcome"
              @oncheckeds="updateValue"
            >
              <span class="tw-text-[14px] tw-text-forTitle">
                Показать на Велком
              </span>
            </BaseCheckboxV2>
          </div>

          <div class="tw-mb-[15px]" ref="academy__welcome_title">
            <div class="tw-app-input-type-3-label">Заголовок на Велком</div>
            <BaseInputNew
              inputClass="tw-app-input-type-3"
              placeholder=""
              class="wp-100 d-flex flex-column align-items-baseline"
              signClass=""
              input-name="academy__welcome_title"
              @input="updateValue"
              :value="dataForModal.academy__welcome_title"
              name-sign=""
              :horizontalTitle="false"
            >
            </BaseInputNew>
          </div>

          <div class="tw-mb-[15px]" ref="academy__welcome_description">
            <div class="tw-app-input-type-3-label">Описание на Велком</div>
            <BaseInputNew
              inputClass="tw-app-input-type-3"
              input-name="academy__welcome_description"
              @input="updateValue"
              :value="dataForModal.academy__welcome_description"
              name-sign=""
              :horizontalTitle="false"
            >
            </BaseInputNew>
          </div>

          <div class="tw-mb-[15px]" ref="academy__welcome_position">
            <div class="tw-app-input-type-3-label">Велком сортировка</div>
            <BaseInputNew
              inputClass="tw-app-input-type-3"
              input-name="academy__welcome_position"
              @input="updateValue"
              :value="dataForModal.academy__welcome_position"
            >
            </BaseInputNew>
          </div>

          <div class="tw-mb-[15px]">
            <div class="tw-app-input-type-3-label">
              {{ dataLang["register_academy_text_9"] }}
            </div>
            <div v-if="fileUrl" class="tw-flex tw-gap-[15px] tw-items-center">
              <a
                :href="fileUrl"
                target="_blank"
                class="tw-app-btn-primary !tw-inline-block"
              >
                ОБЗОР...
              </a>
              <a
                class="!tw-text-forText hover:tw-underline tw-cursor-pointer"
                @click.prevent="
                  () => {
                    fileId = '';
                    fileUrl = '';
                    dataForModal.academy__file_id = '';
                    updateValue({
                      name: 'academy__file_id',
                      value: null,
                    });
                  }
                "
              >
                {{ dataLang["register_academy_text_2"] }}
              </a>
            </div>
            <label v-if="!fileUrl" class="tw-app-btn-primary !tw-inline-block">
              {{ dataLang["reg_company_47"] }}
              <input
                type="file"
                class="d-none"
                accept=".pdf, .txt, .xlsx, .doc"
                @change="(e) => onLoadFile(e)"
              />
            </label>
          </div>

          <div class="tw-mb-[15px]" ref="academy__tags">
            <div class="tw-app-input-type-3-label">
              {{ dataLang["register_academy_text_10"] }}
            </div>
            <BaseTextarea
              inputClass="tw-app-input-type-3"
              input-name="academy__tags"
              @onInput="updateValue"
              :minHeight="'82'"
              :value="dataForModal.academy__tags"
            >
            </BaseTextarea>
          </div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('addNote')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["vehile_modal_btn_reset"] }}
            </button>
            <button
              @click="onSendData"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["register_academy_text_12"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import GeneralService from "@/api/GeneralService";
import httpInstance from "@/http-common";
import { VueTabs, VTab } from "vue-nav-tabs/dist/vue-tabs.js";
import EventBus from "@/event-bus";

export default {
  components: {
    VeTable,
    VueTabs,
    VTab,
  },

  data() {
    return {
      limitPaginationValue: 50,
      sortOption: {
        sortChange: (params) => {
          this.sortChange(params);
        },
      },
      localLoading: true,
      dataTable: [],
      activeSelectRowsMultiple: [],
      filter: [],
      updatedValues: {},
      activePagePagination: {},
      dataForModal: {
        academy__video_link: "https://",
      },
      selectsData: {},
      currentCountry: "",
      currentCountryID: "",
      countriesList: [],
      fileUrl: "",
      fileId: "",
      selectsFilter: { subject: [] },
      isTypeCreateModal: true,
      isOpenModal: false,
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {
              this.isTypeCreateModal = false;

              this.dataForModal = {
                academy__subject: row.academy__subject,
                academy__video_link: row.academy__video_link,
                academy__tags: row.academy__tags,
                academy__id: row.academy__id,

                academy__is_welcome: row.academy__is_welcome,
                academy__welcome_description: row.academy__welcome_description,
                academy__welcome_position: row.academy__welcome_position,
                academy__welcome_title: row.academy__welcome_title,
              };
              this.fileUrl = row.storage_s3__s3_uri;
              this.$modal.show("addNote");
              this.isOpenModal = true;
            },
          };
        },
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {},
      },
    };
  },
  methods: {
    sortChange(params) {
      this.dataTable.sort((a, b) => {
        if (params.academy__video_link) {
          const hasA = !!a.academy__video_link;
          const hasB = !!b.academy__video_link;
          if (params.academy__video_link === "asc") {
            return hasA - hasB;
          } else if (params.academy__video_link === "desc") {
            return hasB - hasA;
          }
        }
        if (params.storage_s3__s3_uri) {
          const hasA = !!a.storage_s3__s3_uri;
          const hasB = !!b.storage_s3__s3_uri;
          if (params.storage_s3__s3_uri === "asc") {
            return hasA - hasB;
          } else if (params.storage_s3__s3_uri === "desc") {
            return hasB - hasA;
          }
        }
        if (params.academy__is_welcome) {
          if (params.academy__is_welcome === "asc") {
            return a.academy__is_welcome - b.academy__is_welcome;
          } else if (params.academy__is_welcome === "desc") {
            return b.academy__is_welcome - a.academy__is_welcome;
          } else {
            return 0;
          }
        }
        if (params.academy__welcome_title) {
          const valA = a.academy__welcome_title;
          const valB = b.academy__welcome_title;
          if (valA === null && valB === null) return 0;
          if (valA === null) return 1;
          if (valB === null) return -1;
          const order = params.academy__welcome_title === "asc" ? 1 : -1;
          return (
            valA.localeCompare(valB, undefined, {
              numeric: true,
              sensitivity: "base",
            }) * order
          );
        }
        if (params.academy__welcome_description) {
          const valA = a.academy__welcome_description;
          const valB = b.academy__welcome_description;
          if (valA === null && valB === null) return 0;
          if (valA === null) return 1;
          if (valB === null) return -1;
          const order = params.academy__welcome_description === "asc" ? 1 : -1;
          return (
            valA.localeCompare(valB, undefined, {
              numeric: true,
              sensitivity: "base",
            }) * order
          );
        }
        if (params.academy__created_at) {
          const toIso = (str) =>
            str
              ? new Date(str.replace(/(\d{2})\.(\d{2})\.(\d{4})/, "$3-$2-$1T"))
              : 0;

          if (params.academy__created_at === "asc") {
            return toIso(a.academy__created_at) - toIso(b.academy__created_at);
          } else if (params.academy__created_at === "desc") {
            return toIso(b.academy__created_at) - toIso(a.academy__created_at);
          } else {
            return 0;
          }
        }
      });
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    selectedAllChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },

    play() {
      this.player.play();
    },
    pause() {
      this.player.pause();
    },

    updateValue(data) {
      this.updatedValues[data.name] = data.value;
    },

    onOpenMainModal() {
      this.isOpenModal = true;
    },

    computedTranslate(values, tranaslate) {
      let keys = Object.keys(values);
      let tranaslateLocal = tranaslate;
      keys.forEach((keyName) => {
        tranaslateLocal = tranaslateLocal.replace(
          `\\${keyName}\\`,
          values[keyName]
        );
      });
      return tranaslateLocal;
    },

    handleTabChange(tabIndex, newTab, oldTab) {},

    onSendData() {
      if (Object.keys(this.updatedValues).length) {
        if (this.isTypeCreateModal) {
          GeneralService.editOrCreate(`/super/academy`, {
            ...this.updatedValues,
            academy__country_id: this.currentCountryID,
          })
            .then((data) => {
              this.$toast.success(data.data.message);
              this.$modal.hide("addNote");
              this.updatedValues = {};
              this.dataForModal = {
                academy__video_link: "https://",
                academy__subject: "",
                academy__country_id: null,
                academy__video_link: "",
                academy__tags: "",
                academy__is_welcome: false,
                academy__welcome_description: "",
                academy__welcome_position: 0,
                academy__welcome_title: "",
              };
              this.fileId = "";
              this.fileUrl = "";
              this.loadData();
            })
            .catch((e) => {
              this.$toast.error(e.response.data.message ?? e, {
                duration: 5000,
              });
            });
        } else {
          GeneralService.edit(
            `/super/academy/${this.dataForModal?.academy__id}`,
            {
              ...this.updatedValues,
              academy__country_id: this.currentCountryID,
            }
          )
            .then((data) => {
              this.$toast.success(data.data.message);
              this.$modal.hide("addNote");
              this.updatedValues = {};
              this.dataForModal = {
                academy__video_link: "https://",
                academy__subject: "",
                academy__country_id: null,
                academy__tags: "",
                academy__is_welcome: false,
                academy__welcome_description: "",
                academy__welcome_position: 0,
                academy__welcome_title: "",
              };
              this.fileId = "";
              this.fileUrl = "";
              this.loadData();
            })
            .catch((e) => {
              this.$toast.error(e.response.data.message ?? e, {
                duration: 5000,
              });
            });
        }
      } else {
        this.$modal.hide("addNote");
      }
    },

    deleteRow() {
      if (this.activeSelectRowsMultiple.length) {
        GeneralService.delete(`/super/academy/${this.activeSelectRowsMultiple}`)
          .then((data) => {
            this.$toast.success(data.data.message);
            this.loadData();
          })
          .catch((e) => {
            if (e.response.data.message) {
              this.$toast.error(e.response.data.message, { duration: 5000 });
            }
          });
      }
    },

    resetFilter() {
      this.$refs.mainTable.$el
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });
      this.filter = [];
      this.loadData();
    },
    updateLimitValue(data) {
      this.limitPaginationValue = data;
      this.loadData();
    },
    loadData(page = 1) {
      this.localLoading = true;
      Promise.all([
        GeneralService.get("/whoami")
          .then((who) => {
            this.currentCountryID = who.data.data.company_default_country_id;
          })
          .catch((e) => {
            console.log(e);
          }),
        GeneralService.get(`/countries`)
          .then((data) => {
            this.countriesList = data.data.data.rows;
          })
          .catch((e) => {
            console.error(e);
          }),
      ]).then(() => {
        GeneralService.get(
          `/super/academy/table/main/${this.currentCountryID}`,
          {
            params: {
              ...this.paginationFinesStateParams,
              page: page,
              limit: this.limitPaginationValue,
              where: JSON.stringify([...this.filter]),
            },
          }
        )
          .then((data) => {
            this.dataTable = data.data.data.rows;
            this.getFinesAll(data.data.data);
            this.currentCountry = this.countriesList.find(
              (x) => x.countries__id == this.currentCountryID
            ).countries__name;
            this.localLoading = false;
          })
          .catch((e) => {
            this.$toast.error("Неизвестная ошибка при загрузке таблицы", {
              duration: 5000,
            });
          });
      });
    },

    fillFilter(data) {
      console.log(data);
      let newValueFilter =
        data.type == "like" ? `;percent;${data.value};percent;` : data.value;
      if (!this.filter.find((x) => x.field == data.name)) {
        this.filter.push({
          field: data.name,
          value: newValueFilter,
          ...(data.type == "like" && { operator: "like" }),
          ...(data.operator && { operator: data.operator }),
          ...(data.mod && { mod: data.mod }),
        });
      } else {
        let indexed = this.filter.findIndex((x) => x.field == data.name);
        this.filter[indexed].value = newValueFilter;
        if (data?.operator) {
          this.filter[indexed].operator = data.operator;
        }
      }
      let indexed = this.filter.findIndex((x) => x.field == data.name);
      if (indexed !== -1) {
        this.filter[indexed].value = newValueFilter;
        if (data.type == "delete") {
          console.log(323323223);
          this.filter.splice(indexed, 1);
        }
      }
    },

    onOpenModalReview() {},

    async onLoadFile(e) {
      this.localLoading = true;
      let file = e.target.files[0];
      let formData = new FormData();
      formData.append("file", file);
      formData.append("type", "default");
      try {
        let dataFrom = await GeneralService.editOrCreate("/storage", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        this.fileUrl = dataFrom.data.data.url;
        this.fileId = dataFrom.data.data.id;
        this.dataForModal.academy__file_id = dataFrom.data.data.id;

        this.updateValue({
          name: "academy__file_id",
          value: dataFrom.data.data.id,
        });
        this.localLoading = false;
      } catch (error) {
        this.$toast.error(error, { duration: 5000 });
        this.$modal.hide("addNote");
      }
    },

    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element["label"] = element[Object.keys(element).pop()];
          element["key"] = key;
          element["value"] = Object.keys(element)[0];
          element["selectName"] = keyDataFromFetch;
        });
      }
      return data;
    },

    ...mapActions("finesPagination", ["getFinesAll"]),
  },
  mounted() {
    EventBus.$on("updateContentData", () => {
      this.loadData();
    });
  },
  created() {
    this.loadData();
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
    ...mapState("finesPagination", ["paginationFinesStateParams"]),
    ...mapGetters("finesPagination", ["numPages"]),
    player() {
      return this.$refs.player;
    },
    columns() {
      return [
        {
          field: "",
          key: "a62",
          type: "checkbox",
          title: "",
          width: "1%",
          align: "center",
        },
        {
          field: "academy__id",
          key: "1623236",
          title: this.dataLang["register_academy_text_3"],
          align: "center",
          width: "5%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class={"h-100"}>
                <div class={"text-center"}>{column.title}</div>

                <BaseInputNew
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  placeholder=""
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"academy__id"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
        },
        {
          field: "academy__subject",
          key: "162336",
          title: this.dataLang["register_academy_text_4"],
          align: "left",
          width: "20%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class={"h-100"}>
                <div class={"text-center"}>{column.title}</div>
                <BaseInputNew
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  placeholder=""
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"academy__subject"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
        },
        {
          field: "academy__video_link",
          key: "12861326",
          title: this.dataLang["register_academy_text_5"],
          align: "center",
          width: "10%",
          sortBy: "",
          ellipsis: {
            showTitle: false,
            lineClamp: false,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span
                style={"-webkit-line-clamp: none !important; display: block;"}
              >
                {row.academy__video_link ? (
                  <div
                    style={
                      "text-decoration: underline; cursor: pointer; -webkit-line-clamp: none;"
                    }
                    onClick={() => {
                      this.$modal.show("modalVideoSupport", {
                        videoID: row.academy__video_link,
                      });
                    }}
                  >
                    Смотреть
                  </div>
                ) : (
                  ""
                )}
              </span>
            );
          },
        },
        {
          field: "storage_s3__s3_uri",
          key: "16336",
          title: this.dataLang["register_academy_text_6"],
          align: "center",
          width: "10%",
          sortBy: "",
          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.storage_s3__s3_uri ? (
                  <a
                    href={row.storage_s3__s3_uri}
                    target="_blank"
                    style={"text-decoration: underline; cursor: pointer"}
                  >
                    Скачать
                  </a>
                ) : (
                  ""
                )}
              </span>
            );
          },
        },
        {
          field: "academy__is_welcome",
          key: "222131313",
          title: "Велком",
          align: "center",
          width: "5%",
          sortBy: "",
          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return <span>{!!row.academy__is_welcome ? "Да" : "Нет"}</span>;
          },
        },
        {
          field: "academy__welcome_title",
          key: "2221313",
          title: "Заголовок на Велком",
          align: "center",
          width: "15%",
          sortBy: "",
          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
        },
        {
          field: "academy__welcome_description",
          key: "225513",
          title: "Описание на Велком",
          align: "center",
          width: "15%",
          sortBy: "",
          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
        },
        {
          field: "academy__created_at",
          key: "136326",
          title: this.dataLang["register_academy_text_7"],
          align: "center",
          width: "10%",
          sortBy: "",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.academy__created_at
                  ? this.$time(row.academy__created_at)
                      .utc(true)
                      .utcOffset(Number(this.userSetting.company__utc))
                      .format(
                        `${this.userSetting.company__tempalte_date} HH:mm`
                      )
                  : ""}
              </span>
            );
          },
        },
      ];
    },
  },
};
</script>
